import React, { useEffect, useState } from "react";
import { PhoneInput } from "react-international-phone";
import parsePhoneNumber from "libphonenumber-js";

import "react-international-phone/style.css";
import { validatePhoneNumber } from "../../services";

type AppPhoneInputProps = {
  value?: string;
  onChange: (data: {
    full: string;
    countryCode: string;
    number: string;
    isValid: boolean;
  }) => void;
  defaultCountry?: string;
  onTouch: () => void;
};

export const AppPhoneInput: React.FC<AppPhoneInputProps> = ({
  value = "",
  onChange,
  defaultCountry = "kw",
  onTouch,
}) => {
  const [phone, setPhone] = useState(value);
  const [isValid, setIsValid] = useState<boolean>();

  useEffect(() => {
    if (!phone) return;
    try {
      const parsedPhoneNumber = parsePhoneNumber(phone);
      if (parsedPhoneNumber) {
        const { countryCallingCode, nationalNumber, country } =
          parsedPhoneNumber;
        const _isValid = validatePhoneNumber(
          countryCallingCode,
          nationalNumber,
          country as string
        );
        setIsValid(_isValid);
        onChange({
          full: phone,
          countryCode: countryCallingCode || "",
          number: nationalNumber || "",
          isValid: _isValid,
        });
      }
    } catch {
      onChange({ full: phone, countryCode: "", number: "", isValid: false });
    }
  }, [phone]);

  useEffect(() => {
    setPhone(value)
  }, [value]);

  const [touched, setTouched] = useState<boolean>(false);

  return (
    <div>
      <PhoneInput
        onFocus={() => {
          setTouched(true);
          onTouch();
        }}
        defaultCountry={defaultCountry}
        value={phone}
        onChange={setPhone}
        inputStyle={{ width: "100%" }}
      />
      {touched && !isValid && (
        <small style={{ color: "red" }}>Phone number is not valid</small>
      )}
    </div>
  );
};
